<template>
  <section>
    <GiftSubscriptionCard
      v-if="authenticated && subscriptionsEnabled"
      class="dd-home-gift"
      :title="$t('wall.subscription.gift_card_title')"
      :subtitle="$t('wall.subscription.gift_card_subtitle')"
      :note="$t('wall.subscription.gift_note_90_days')"
      :button-text="$t('wall.subscription.gift_button')"
      @action="openGiftFlow"
    >
      <template #actions>
        <SigninWithGoogle v-if="!authenticated" :href="giftLoginHref" />
        <button v-else class="btn-orange" type="button" @click="openGiftFlow">
          {{ $t('wall.subscription.gift_button') }}
        </button>
      </template>
    </GiftSubscriptionCard>
    <div v-if="!posts.length" class="dd-wall-card dd-welcome-card">
      <h2>{{ $t('wall.home.welcome_title', {name: channelName}) }}</h2>
      <p>{{ $t('wall.home.welcome_subtitle') }}</p>
      <p v-if="!wallEnabledGlobal" class="muted">{{ $t('wall.home.wall_disabled_global') }}</p>
      <p v-else-if="!wallEnabledChannel" class="muted">{{ $t('wall.home.wall_disabled_channel') }}</p>
      <p v-else class="muted">{{ noPostsHint }}</p>
      <div v-if="!authenticated" class="dd-login-bottom-right">
        <SigninWithGoogle/>
      </div>
      <div v-if="authenticated && !isSponsor" class="mt">
        <div class="dd-wall-card" v-if="subscriptionsEnabled">
          <p>{{ $t('wall.home.not_a_sponsor_cta') }}</p>
          <button class="btn-orange" @click="$router.push('/wall/subscription')">{{ $t('wall.tabs.subscription') }}</button>
        </div>
        <div class="dd-wall-card mt" v-if="donationAvailable">
          <p>{{ donationText }}</p>
          <button class="btn-orange" @click="$router.push('/wall/effects')">{{ donationButtonText }}</button>
        </div>
      </div>
    </div>
    <PostFeed v-else :show-login-tile="true" />
  </section>
</template>

<script>
import PostFeed from '@/new/components/wall/PostFeed.vue';
import SigninWithGoogle from '@/new/components/general/SigninWithGoogle.vue';
import GiftSubscriptionCard from '@/new/components/wall/GiftSubscriptionCard.vue';

export default {
  name: 'WallHome',
  components: {PostFeed, SigninWithGoogle, GiftSubscriptionCard},
  computed: {
    posts() { return this.$store.getters.posts; },
    channelName() { return this.$store.getters.visuals?.name || ''},
    authenticated() { return this.$store.getters.authenticated; },
    isSponsor() { return this.$store.getters.isSponsor; },
    wallEnabledGlobal() { return this.$store.getters.wallEnabledGlobal ?? true; },
    wallEnabledChannel() { return this.$store.getters.wallEnabledChannel ?? true; },
    subscriptionsEnabled() { return this.$store.getters.subscriptionsEnabled; },
    donationAvailable() { return this.$store.getters.oneTimeDonationsAvailable; },
    donationOnlyMode() { return this.$store.getters.donationOnlyMode; },
    noPostsHint() {
      return this.donationOnlyMode ? this.$t('wall.home.no_posts_yet_donation_hint') : this.$t('wall.home.no_posts_yet_hint');
    },
    donationText() {
      return this.donationOnlyMode ? this.$t('wall.home.support_with_donation_only') : this.$t('wall.home.support_with_donation');
    },
    donationButtonText() {
      return this.donationOnlyMode ? this.$t('forms.payment_mode_donation') : this.$t('wall.tabs.effects');
    },
    giftLoginHref() {
      return `/login?provider=google&redirect=${encodeURIComponent('/wall/subscription?open_gift=1')}`;
    },
  },
  methods: {
    openGiftFlow() {
      this.$router.push('/wall/subscription?open_gift=1');
    },
  },
}
</script>

<style scoped>
.dd-home-gift {
  margin-bottom: 16px;
}
</style>
